import { NA_LABEL } from 'pages/RideListPage/const';

/**
 * @typedef {object} VehicleAssignmentInput
 * @property {string} [busNumber]
 * @property {string} [mobilityPartnerName]
 * @property {'BUS' | 'TRAIN' | string} [vehicleType]
 */

/**
 * @typedef {object} VehicleTagData
 * @property {string} tooltipContent Text shown inside the tooltip balloon.
 * @property {string} busLabel Text shown inside the tag body next to the icon.
 */

/**
 * Build the display data for a vehicle tag from a raw vehicle assignment.
 *
 * @param {object} [args]
 * @param {VehicleAssignmentInput | null | undefined} [args.vehicleAssignment]
 * @param {string} [args.fallbackLabel]
 * @returns {VehicleTagData}
 */
export const buildVehicleTagData = ({ vehicleAssignment = {}, fallbackLabel = NA_LABEL } = {}) => {
	const { mobilityPartnerName, busNumber } = vehicleAssignment ?? {};

	return {
		tooltipContent: mobilityPartnerName ?? fallbackLabel,
		busLabel: busNumber ?? fallbackLabel,
	};
};
